<template>
  <div class="sidebar-detached sidebar-left">
    <div class="sidebar">
      <div class="sidebar-shop" :class="{ show: mqShallShowLeftSidebar }">
        <b-row>
          <b-col cols="12">
            <!-- <h6 class="filter-heading d-none d-lg-block">
              {{ $t("advisor.Advisor_Filters") }}
            </h6> -->
          </b-col>
        </b-row>

        <!-- Filters' Card -->
        <b-card class="divFilters">
          <b-row>
            <b-col cols="12" class="">
              <h6 class="filter-heading d-none d-lg-block">
                {{ $t("advisor.Advisor_Filters") }}
              </h6>
              <b-button
                type="reset"
                variant="outline-secondary"
                @click="reset"
                class="mb-2 resetBtn"
              >
                {{ $t("advisor.Reset") }}
              </b-button>
            </b-col>
          </b-row>
          <br />
          <div class="price-slider">
            <h6 class="filter-title mt-0">
              {{ $t("advisor.Exprerince") }}
            </h6>
            <vue-slider
              v-model="filters.experience"
              :min="1"
              stacked
              :max="40"
              :direction="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            />
            <label>{{
              $store.state.locale.locale === "en" ? calcExp : arCalcExp
            }}</label>
          </div>
          <br />
          <div id="app" class="price-slider">
            <h6 class="filter-title mt-0">
              {{ $t("advisor.Skills") }}
            </h6>
            <treeselect
              v-model="filters.skills"
              :multiple="true"
              label="skills ..."
              :options="skills"
              :normalizer="
                $store.state.locale.locale == 'ar'
                  ? normalizerArabic
                  : normalizer
              "
            />
          </div>
          <div id="app" class="price-slider">
            <h6 class="filter-title mt-1">
              {{ $t("advisor.Target_Industries") }}
            </h6>
            <treeselect
              v-model="filters.industry"
              :multiple="true"
              label="industry ..."
              :options="industries"
              :normalizer="
                $store.state.locale.locale == 'ar'
                  ? normalizerArabic
                  : normalizer
              "
            />
          </div>
          <!-- Location -->
          <div class="price-slider">
            <h6 class="filter-title mt-1">
              {{ $t("advisor.Languages") }}
            </h6>
            <treeselect
              v-model="filters.languages"
              :multiple="true"
              label="nationaity ..."
              :options="calcLanguages"
            />
          </div>
          <div id="app" class="price-slider">
            <h6 class="filter-title mt-1">
              {{ $t("advisor.Location") }}
            </h6>
            <treeselect
              v-model="filters.location"
              :multiple="true"
              label="location ..."
              :options="countries"
            />
          </div>
          <!-- Ratings -->
          <div class="ratings">
            <h6 class="filter-title">
              {{ $t("advisor.Ratings") }}
            </h6>
            <div
              v-for="rating in filterOptions.ratings"
              :key="rating.rating"
              class="ratings-list"
            >
              <b-link>
                <div class="d-flex">
                  <feather-icon
                    v-for="star in 5"
                    :key="star"
                    icon="StarIcon"
                    size="17"
                    :class="[
                      { 'fill-current': star <= rating.rating },
                      star <= rating.rating ? 'text-warning' : 'text-muted',
                    ]"
                    @click="log(rating.rating)"
                  />
                  <span class="ml-25"> {{ $t("advisor.up") }}</span>
                </div>
              </b-link>
              <div class="stars-received">
                <span>{{ rating.count }}</span>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <div
      class="body-content-overlay"
      :class="{ show: mqShallShowLeftSidebar }"
      @click="$emit('update:mq-shall-show-left-sidebar', false)"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import languages from "@/store/country/nationality.json";

import { BRow, BButton, BCol, BCard, BLink } from "bootstrap-vue";
import VueSlider from "vue-slider-component";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BButton,
    Treeselect,
    // 3rd Party
    VueSlider,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    filterOptions: {
      type: Object,
      required: true,
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      languages,
    };
  },
  computed: {
    calcExp() {
      // `this` points to the component instance
      return `between: ${this.filters.experience[0]}Y - ${this.filters.experience[1]}Y`;
    },
    arCalcExp() {
      // `this` points to the component instance
      return `مابين: ${this.filters.experience[0]} سنة - ${this.filters.experience[1]}  سنة  `;
    },
    calcLanguages() {
      return this.languages.map((row) => ({ id: row.text, label: row.text }));
    },
    estInterval() {
      // `this` points to the component instance
      return (this.filters.Established[1] - this.filters.Established[0]) / 1;
    },
    ...mapGetters({
      categories: "profile/getCompanyCategories",
      industries: "profile/getAllIndustries",
      skills: "profile/getAllSkillsId",
      countries: "country/getFilterCountries",
    }),
  },
  mounted() {
    this.fetchCategories();
    this.fetchIndustries();
    this.fetchSkills();
    this.fetchCountries();
  },
  methods: {
    normalizerArabic(node) {
      return {
        id: node.id,
        label: node.arabicName != null ? node.arabicName : node.label,
        children: node.children,
      };
    },
    normalizer(node) {
      return {
        id: node.id,
        label: node.label,
        children: node.children,
      };
    },
    reset() {
      this.filters.experience = [0, 40];
      this.filters.skills = null;
      this.filters.industry = [];
      this.filters.location = [];
      this.filters.q = "";
      this.filters.languages = [];
      this.filters.ratings = null;
    },
    log(id) {
      this.filters.ratings = id;
    },
    ...mapActions({
      fetchCategories: "profile/retreiveCategories",
      fetchIndustries: "profile/retreiveIndustries",
      fetchCurrencies: "currency/retreiveCurrencies",
      fetchSkills: "profile/retreiveSkills",
      fetchCountries: "country/retreiveCountries",
    }),
  },
};
</script>

<style lang="scss">
@import "~@core/scss/vue/libs/vue-slider.scss";
</style>

<style lang="scss" scoped>
.categories-radio-group,
.brands-radio-group,
.price-range-defined-radio-group {
  ::v-deep > .custom-control {
    margin-bottom: 0.75rem;
  }
}
</style>
<style>
@media (max-width: 991.98px) {
  [dir] .ecommerce-application .sidebar-left .sidebar .sidebar-shop.show {
    margin-top: 65px;
  }
}
</style>
<style scoped>
.divFilters {
  background-color: #fff;
  margin-top: 3rem;
  /* padding-top: 20px; */
}
@media (max-width: 600px) {
  .divFilters {
    margin-top: 1rem;
  }
}

div.card.ebitdaBlock {
  border-top: 1px solid #ebe9f1;
}
.resetBtn {
  width: 88%;
}
.divFilters h6 {
  font-weight: 500;
  font-size: 1.1rem;
}
</style>
